import {
  IconButton,
  Checkbox,
  HStack,
  Button,
  Text,
  Modal,
  ModalHeader,
  ModalCloseButton,
  Box,
  Flex,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Center,
  Table,
  Thead,
  Tr,
  Th,
  useDisclosure,
  Td,
  Tbody,
  Divider,
  Tab,
  Tabs,
  TabPanel,
  TabPanels,
  TabList
} from '@chakra-ui/react'
import { format, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'

import useSupply from '@hook/parametrization/use-supply'
import useTable from '@hook/shared/use-table'

import LayoutLoader from '@component/Layout/Loader'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridParametrizationSupplyItem: FC<{ [key: string]: any }> = ({
  data
}) => {
  const { actions, columns, query } = useTable()
  const {
    dataHistoric,
    loadingModalHistoric,
    getHistoricUpdate,
    dataHistoricUpdate,
    getHistoricLeadTime,
    loadingModalHistoricLeadTime,
    dataHistoricLeadTime,
    getFieldValidationStatus
  } = useSupply()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left',
            isNumeric: row.isNumeric
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'default') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal s"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                  />
                )
              }

              if (action.type === 'icon') {
                return (
                  <>
                    <Modal
                      isCentered
                      isOpen={isOpen}
                      onClose={onClose}
                      scrollBehavior="inside"
                      motionPreset="slideInBottom"
                      colorScheme="white"
                      size="6xl"
                    >
                      <ModalOverlay />
                      <ModalContent
                        background={'white'}
                        marginLeft={[4, 8, 16]}
                        marginRight={[4, 8, 16]}
                      >
                        <ModalHeader
                          paddingTop={2}
                          paddingBottom={2}
                          paddingLeft={4}
                          paddingRight={4}
                          textColor={'gray.200'}
                          background={'#1d5840'}
                          borderTopLeftRadius={5}
                          borderTopRightRadius={5}
                          borderBottom="3px solid #ECC94B"
                        >
                          <Flex alignItems="center">
                            <Text marginLeft={2}>Histórico</Text>
                          </Flex>
                        </ModalHeader>
                        <ModalCloseButton
                          top={1}
                          right={1.5}
                          textColor={'gray.200'}
                          size="lg"
                        />
                        <ModalBody bg="white">
                          <Tabs variant="soft-rounded" colorScheme="green">
                            <TabList>
                              <Tab>Alteracao</Tab>
                              <Tab>LeadTime</Tab>
                            </TabList>
                            <TabPanels>
                              <TabPanel>
                                {loadingModalHistoric ? (
                                  <LayoutLoader
                                    type="modal"
                                    title="Recuperando informações..."
                                    message="Aguarde enquanto buscamos os registros no banco de dados"
                                  />
                                ) : (
                                  <>
                                    {dataHistoric.possuiHistorico ||
                                    dataHistoricUpdate.length > 0 ? (
                                      <Tabs variant="enclosed">
                                        <TabList>
                                          {dataHistoricUpdate.length > 0 ? (
                                            <Tab>Histórico</Tab>
                                          ) : (
                                            <></>
                                          )}
                                        </TabList>

                                        <TabPanels>
                                          {dataHistoricUpdate.length > 0 && (
                                            <TabPanel>
                                              {loadingModalHistoric ? (
                                                <LayoutLoader
                                                  type="modal"
                                                  title="Recuperando informações..."
                                                  message="Aguarde enquanto buscamos os registros no banco de dados"
                                                />
                                              ) : (
                                                <>
                                                  <Divider />
                                                  <Text
                                                    fontSize={'sm'}
                                                    fontWeight="bold"
                                                  >
                                                    Dados das últimas
                                                    alterações:
                                                  </Text>
                                                  <Text
                                                    fontSize={'sm'}
                                                    fontWeight="bold"
                                                  >
                                                    Centro:{' '}
                                                    {data['centro-codigo']}
                                                  </Text>
                                                  <Text
                                                    fontSize={'sm'}
                                                    fontWeight="bold"
                                                    pb={6}
                                                  >
                                                    Produto:{' '}
                                                    {data['produto-id']}
                                                  </Text>
                                                  <Box
                                                    p={4}
                                                    pos="relative"
                                                    h={380}
                                                    maxW="100%"
                                                    overflow="auto"
                                                  >
                                                    <Table
                                                      size="sm"
                                                      style={{
                                                        borderCollapse:
                                                          'separate',
                                                        maxHeight: 20
                                                      }}
                                                      className="scl-table-grid"
                                                    >
                                                      <Thead
                                                        style={{
                                                          background: '#EDF2F7',
                                                          position: 'sticky',
                                                          top: -20,
                                                          zIndex: 1
                                                        }}
                                                      >
                                                        <Tr
                                                          textTransform={
                                                            'capitalize'
                                                          }
                                                        >
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Data
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Usuario
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Abastecer
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Tipo Suprimento
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Usar Politica de
                                                            Estoque
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Incluir Previsao
                                                            Tempo de Espera
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Utilizar Estoque
                                                            Minimo
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            eMax
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Frequencia de
                                                            Pedidos
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            LeadTime
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Lote Multiplo
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Politica Estoque
                                                            Arbitraria
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Lote Minimo CD
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Estoque Arbitrado
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Estoque Minimo
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            CD Origem
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Status
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Utilizar Ponto de
                                                            Pedido
                                                          </Th>
                                                          <Th
                                                            textTransform={
                                                              'capitalize'
                                                            }
                                                          >
                                                            Comentário
                                                          </Th>
                                                        </Tr>
                                                      </Thead>
                                                      <Tbody>
                                                        {dataHistoricUpdate.length ===
                                                        0 ? (
                                                          <Tr>
                                                            <Td
                                                              colSpan={18}
                                                              align="center"
                                                            >
                                                              Dados não
                                                              encontrados
                                                            </Td>
                                                          </Tr>
                                                        ) : (
                                                          dataHistoricUpdate.map(
                                                            value => (
                                                              <>
                                                                <Tr>
                                                                  <Td>
                                                                    {value?.data
                                                                      ? format(
                                                                          parseISO(
                                                                            value?.data.toString()
                                                                          ),
                                                                          'dd/MM/yyyy HH:mm:ss'
                                                                        )
                                                                      : ''}
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.login
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.abastecer
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.tipoSuprimento
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.usarPoliticaDeEstoque
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.incluirPrevisaoTempoDeEspera
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.utilizarEstoqueMinimo
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.eMax
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.frequenciaDePedidos
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.leadTime
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.loteMultiplo
                                                                    }
                                                                  </Td>

                                                                  <Td>
                                                                    {
                                                                      value?.politicaEstoqueArbitraria
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.loteMinimoCD
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.estoqueArbitrado
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.estoqueMinimo
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.cdOrigem
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.status
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {
                                                                      value?.utilizarPontoPedido
                                                                    }
                                                                  </Td>
                                                                  <Td>
                                                                    {value?.comentario ??
                                                                      '—'}
                                                                  </Td>
                                                                </Tr>
                                                              </>
                                                            )
                                                          )
                                                        )}
                                                      </Tbody>
                                                    </Table>
                                                  </Box>
                                                </>
                                              )}
                                            </TabPanel>
                                          )}
                                        </TabPanels>
                                      </Tabs>
                                    ) : (
                                      <Box>
                                        <Flex
                                          flexDir="column"
                                          alignItems="center"
                                          justifyContent="center"
                                          bg="white"
                                          borderRadius="8px"
                                          h="calc(30vh - 128px)"
                                          p={8}
                                        >
                                          <Text
                                            maxW="460px"
                                            fontSize={18}
                                            textAlign="center"
                                          >
                                            Não existe registro de alterações
                                            para o centro{' '}
                                            {data['centro-codigo']} e o produto{' '}
                                            {data['produto-id']}.
                                          </Text>
                                        </Flex>
                                      </Box>
                                    )}
                                  </>
                                )}
                              </TabPanel>
                              <TabPanel>
                                {loadingModalHistoricLeadTime ? (
                                  <LayoutLoader
                                    type="modal"
                                    title="Recuperando informações..."
                                    message="Aguarde enquanto buscamos os registros no banco de dados"
                                  />
                                ) : (
                                  <>
                                    {loadingModalHistoricLeadTime ? (
                                      <LayoutLoader
                                        type="modal"
                                        title="Recuperando informações..."
                                        message="Aguarde enquanto buscamos os registros no banco de dados"
                                      />
                                    ) : (
                                      <>
                                        <Divider />
                                        <Text fontSize={'sm'} fontWeight="bold">
                                          Dados das últimas alterações:
                                        </Text>
                                        <Text fontSize={'sm'} fontWeight="bold">
                                          Centro: {data['centro-codigo']}
                                        </Text>
                                        <Text
                                          fontSize={'sm'}
                                          fontWeight="bold"
                                          pb={6}
                                        >
                                          Produto: {data['produto-id']}
                                        </Text>
                                        <Box
                                          p={4}
                                          pos="relative"
                                          h={380}
                                          maxW="100%"
                                          overflow="auto"
                                        >
                                          <Table
                                            size="sm"
                                            style={{
                                              borderCollapse: 'separate',
                                              maxHeight: 20
                                            }}
                                            className="scl-table-grid"
                                          >
                                            <Thead
                                              style={{
                                                background: '#EDF2F7',
                                                position: 'sticky',
                                                top: -20,
                                                zIndex: 1
                                              }}
                                            >
                                              <Tr textTransform={'capitalize'}>
                                                <Th
                                                  textTransform={'capitalize'}
                                                >
                                                  Data
                                                </Th>
                                                {/* <Th
                                                  textTransform={'capitalize'}
                                                >
                                                  Id Loja
                                                </Th>
                                                <Th
                                                  textTransform={'capitalize'}
                                                >
                                                  Id Produto
                                                </Th> */}
                                                <Th
                                                  textTransform={'capitalize'}
                                                >
                                                  Id Fornecedor
                                                </Th>
                                                <Th
                                                  textTransform={'capitalize'}
                                                >
                                                  LeadTime
                                                </Th>
                                              </Tr>
                                            </Thead>
                                            <Tbody>
                                              {dataHistoricLeadTime.length ===
                                              0 ? (
                                                <Tr>
                                                  <Td
                                                    colSpan={16}
                                                    align="center"
                                                  >
                                                    Dados não encontrados
                                                  </Td>
                                                </Tr>
                                              ) : (
                                                dataHistoricLeadTime.map(
                                                  value => (
                                                    <>
                                                      <Tr>
                                                        <Td>
                                                          {value?.data
                                                            ? format(
                                                                parseISO(
                                                                  value?.data.toString()
                                                                ),
                                                                'dd/MM/yyyy HH:mm:ss'
                                                              )
                                                            : ''}
                                                        </Td>
                                                        {/* <Td>{value?.idLoja}</Td>
                                                        <Td>
                                                          {value?.idProduto}
                                                        </Td> */}
                                                        <Td>
                                                          {value?.idFornecedor}
                                                        </Td>
                                                        <Td>
                                                          {value?.leadTime}
                                                        </Td>
                                                      </Tr>
                                                    </>
                                                  )
                                                )
                                              )}
                                            </Tbody>
                                          </Table>
                                        </Box>
                                      </>
                                    )}
                                  </>
                                )}
                              </TabPanel>
                            </TabPanels>
                          </Tabs>

                          <Center>
                            <Box
                              p={2}
                              alignItems="center"
                              alignContent="center"
                            >
                              <Button
                                colorScheme="red"
                                mr={3}
                                onClick={onClose}
                              >
                                Fechar
                              </Button>
                            </Box>
                          </Center>
                        </ModalBody>
                      </ModalContent>
                    </Modal>
                    <IconButton
                      key={`table-action-${index}`}
                      aria-label="Abrir modal t"
                      icon={action.icon}
                      size="xs"
                      onClick={() => {
                        getHistoricUpdate(
                          data['produto-id'],
                          data['centro-codigo']
                        )
                        getHistoricLeadTime(
                          data['produto-id'],
                          data['centro-codigo']
                        )
                        onOpen()
                      }}
                      _hover={{
                        bg: 'yellow.200'
                      }}
                      _active={{
                        bg: 'yellow.100'
                      }}
                    />
                  </>
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="red"
                      isChecked={action.selecteds.includes(data['id-id'])}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align, isNumeric }, key) => {
        const validation = getFieldValidationStatus
          ? getFieldValidationStatus(data, id)
          : { isValid: true, message: '' }
        const isRequired =
          columns.find(
            col =>
              col.columns &&
              col.columns.some(
                c => c.id === id && (c.isRequired || c.isConditionalRequired)
              )
          ) !== undefined

        return (
          <td
            key={`${id}-${key}`}
            align={align || 'left'}
            style={{
              background:
                !validation.isValid && isRequired ? '#FED7D7' : 'transparent'
            }}
          >
            <Box
              justifyContent={isNumeric ? 'center' : null}
              textAlign={isNumeric ? 'center' : null}
              borderRadius={!validation.isValid && isRequired ? '4px' : 'none'}
              padding={!validation.isValid && isRequired ? '4px 6px' : '0'}
              title={
                !validation.isValid && isRequired
                  ? validation.message
                  : undefined
              }
              bg={!validation.isValid && isRequired ? '#FED7D7' : 'transparent'}
            >
              {query.length > 0 ? (
                <Highlighter
                  searchWords={String(query).split(' ')}
                  textToHighlight={String(value)}
                />
              ) : (
                value
              )}
            </Box>
          </td>
        )
      })}
    </tr>
  )
}

export default TableGridParametrizationSupplyItem
